export const iconFontAwesomeDisasterCrisisHurricane = (
	<i className="fa-solid fa-hurricane"></i>
);
